// Fills with scroll through a CSS scroll timeline: the document by default, the nearest scroll container with panel.
export default function ReadingProgress(props) {
  return (
    <div
      aria-hidden="true"
      class={`reading-progress no-print h-[3px] bg-cyan origin-left rtl:origin-right pointer-events-none ${
        props.panel ? "reading-progress-panel sticky top-0 z-20 -mb-[3px]" : "fixed inset-x-0 top-[var(--nav-height,0px)] z-30"
      }`}
    />
  );
}
